import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/isolation-mode.svg'


const _hoisted_1 = {
  id: "modal-plugin-certificate-password-tip",
  class: "modal modal-md fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_7 = { class: "modal-footer py-3" }

import { Modal } from 'bootstrap'

  import { ref, onMounted } from 'vue'

  import Icon from '@/components/Atoms/Icon.vue'
  import { useModalControl } from '../store/pinia/useModalControl.store'
  import usePluginCertificatePasswordModal from '../composables/usePluginCertificatePasswordModal'
  import { wait } from '@/utils/helpers'
  import useSetNewPassword from '../composables/useSetNewPassword'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPluginCertificatePasswordTip',
  props: {
    isDifferentPass: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['chosePasswordConfirm'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const emit = __emit
  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const props = __props

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-certificate-password-tip', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function hide() {
    modal.value?.hide()
  }

  function show() {
    modal.value?.show()
  }

  async function advanceNextStep(): Promise<void> {
    const modalControlStore = useModalControl()
    const { hideSetNewPasswordModal, showSetNewPasswordModal } =
      useSetNewPassword()

    hide()

    if (!props.isDifferentPass) {
      return wait(500).finally(() => {
        emit('chosePasswordConfirm')
      })
    }

    return modalControlStore.show({
      modalId: 'setNewPasswordModal',
      hide: hideSetNewPasswordModal,
      show: showSetNewPasswordModal,
    })
  }

  async function comeBack(): Promise<void> {
    const modalControlStore = useModalControl()
    const {
      showPluginCertificatePasswordModal,
      hidePluginCertificatePasswordModal,
    } = usePluginCertificatePasswordModal()

    modalControlStore.show({
      modalId: 'pluginCertificatePasswordModal',
      show: showPluginCertificatePasswordModal,
      hide: hidePluginCertificatePasswordModal,
    })
  }

  __expose({ hide, show })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-header pb-3 border-bottom" }, [
          _createElementVNode("h5", { class: "modal-title plugin-modal-title text-danger" }, "Atenção!")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            alt: "modo de isolamento",
            src: _imports_0
          }, null, -1)),
          (__props.isDifferentPass)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [
                _createElementVNode("p", { class: "fs-6 text-start" }, [
                  _createTextVNode(" Você escolheu "),
                  _createElementVNode("strong", null, "criar uma senha"),
                  _createTextVNode(" para usar seu Certificado Digital. ")
                ], -1),
                _createElementVNode("p", { class: "fs-6 text-start pt-3" }, [
                  _createElementVNode("strong", null, "Essa senha não substitui a senha de emissão.")
                ], -1),
                _createElementVNode("p", { class: "fs-6 text-start pt-3" }, " Tem certeza de que deseja continuar? ", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
                _createElementVNode("p", { class: "fs-6 text-start" }, [
                  _createTextVNode(" Você escolheu a "),
                  _createElementVNode("strong", null, "senha de emissão para ser a senha de uso"),
                  _createTextVNode(" do seu Certificado Digital. ")
                ], -1),
                _createElementVNode("p", { class: "fs-6 text-start pt-3" }, " Tem certeza de que deseja continuar? ", -1)
              ])))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            type: "button",
            onClick: comeBack
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("span", null, "Alterar escolha ", -1)
          ])),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: advanceNextStep
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Desejo continuar", -1)),
            _createVNode(Icon, {
              class: "ms-2",
              name: "arrow-right"
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})